import { Reveal } from "@/components/Reveal";
import { COMPARISON_ROWS } from "@/data/content";

const Comparison = () => (
  <section id="compare" className="py-28 md:py-36 border-y border-white/10 bg-[#121212]/30" data-testid="comparison-section">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal className="mb-16">
        <p className="font-mono-p text-xs tracking-[0.35em] uppercase text-[#A1A1AA] mb-4">
          The Scorecard
        </p>
        <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight max-w-3xl">
          Eight rows that decide everything.
        </h2>
      </Reveal>

      <Reveal>
        <div className="border border-white/10" data-testid="comparison-table">
          <div className="grid grid-cols-[1fr] md:grid-cols-[1.1fr_1.5fr_1.5fr] border-b border-white/10 bg-[#0A0A0A]">
            <div className="hidden md:block p-5 font-mono-p text-[10px] tracking-[0.25em] uppercase text-[#A1A1AA]">
              Category
            </div>
            <div className="p-5 font-oswald text-sm tracking-[0.3em] uppercase text-[#0055FF] md:border-l border-white/10">
              Windows PC
            </div>
            <div className="p-5 font-oswald text-sm tracking-[0.3em] uppercase text-[#FF3300] border-t md:border-t-0 md:border-l border-white/10">
              Macintosh
            </div>
          </div>
          {COMPARISON_ROWS.map((row, i) => (
            <div
              key={row.label}
              data-testid={`comparison-row-${i}`}
              className="grid grid-cols-1 md:grid-cols-[1.1fr_1.5fr_1.5fr] border-b border-white/10 last:border-b-0 hover:bg-white/[0.02] transition-colors duration-300"
            >
              <div className="p-5 font-oswald text-sm tracking-[0.15em] uppercase text-[#F5F5F5] bg-[#0A0A0A]/50">
                {row.label}
              </div>
              <div className="p-5 font-mono-p text-sm text-[#A1A1AA] md:border-l border-white/10">
                {row.win}
              </div>
              <div className="p-5 font-mono-p text-sm text-[#A1A1AA] border-t md:border-t-0 md:border-l border-white/10">
                {row.mac}
              </div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default Comparison;
